import React from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";

/*  Our LOCAL component imports */
import { Chevron, StudioIcon } from "../../../../Components/StudioIcons";

/*  Our GLOBAL component imports */
import { Subheader } from "../../../../../../Components/Text";
import { LoadingSkeleton } from "../../../../../../Components/Skeloton";
import { useTranslation } from "react-i18next";

export default function FacetCheck({
  identifier,
  item,
  onQuery,
  query,
  facetLoading,
}: any) {
  const checked = Boolean(query[identifier]?.includes(item.label));
  const { t } = useTranslation("translation", { keyPrefix: "studioFacet" });
  return (
    <Box>
      <StyledCheckboxFlex
        checked={checked}
        justifyContent="space-between"
        onClick={() => {
          onQuery(!checked, identifier, item.label);
        }}
      >
        <Flex>
          <Flex flexShrink={0} alignItems="center">
            <StudioIcon type={item.label} size={18} />
          </Flex>
          <StyledLabelText checked={checked}>
            {t(item.label, { defaultValue: item.label })}
          </StyledLabelText>
        </Flex>

        <StyledSubheader checked={checked} alignSelf="flex-end">
          {facetLoading ? (
            <LoadingSkeleton color={"#1F2A33"} height={15} width={18} />
          ) : (
            `${item.count}`
          )}
        </StyledSubheader>
      </StyledCheckboxFlex>
    </Box>
  );
}

const StyledCheckboxFlex = styled(Flex)`
  align-items: center;
  background-color: ${(props: any) =>
    props.checked ? props.theme.colors.darkerNed : props.theme.colors.nedLight};
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 8px;
  &:hover {
    background-color: ${(props) => props.theme.colors.darkerNed};
    color: ${(props) => props.theme.colors.ice};
    padding: 10px;
  }
  &:hover ${Chevron} {
    color: ${(props) => props.theme.colors.envy};
  }
`;

const StyledLabelText = styled.span<any>`
  font-weight: ${(props: any) => (props.checked ? 500 : 500)};
  font-size: 14px;
  color: ${(props: any) => (props.checked ? props.theme.colors.ice : null)};
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px 5px;
  line-height: 1.6em;
`;

const StyledSubheader = styled(Subheader)`
  font-weight: ${(props: any) => (props.checked ? 600 : 500)};
  font-size: 13px;
  color: ${(props: any) => (props.checked ? "#6f8ddc" : null)};
  background: ${(props: any) => (props.checked ? null : null)};
  padding: 5px;
  width: 32px;
  height: 32px;
  border-radius: ${(props: any) => (props.checked ? "999px" : null)};
  line-height: 1.6em;
  text-overflow: ellipsis;
  white-space: nowrap;
  justify-content: center;
  display: flex;
`;
